interface AutoApplySetupSessionModifications {
    profileModified?: boolean;
}

const AUTO_APPLY_SETUP_SESSION_MODIFICATIONS_KEY = 'autoApplySetup.sessionModifications';

const readSessionModifications = (): AutoApplySetupSessionModifications => {
    if (typeof window === 'undefined') {
        return {};
    }

    try {
        const value = window.sessionStorage.getItem(AUTO_APPLY_SETUP_SESSION_MODIFICATIONS_KEY);
        if (!value) {
            return {};
        }

        const parsed: unknown = JSON.parse(value);
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
            ? (parsed as AutoApplySetupSessionModifications)
            : {};
    } catch {
        return {};
    }
};

const writeSessionModifications = (modifications: AutoApplySetupSessionModifications): void => {
    if (typeof window === 'undefined') {
        return;
    }

    try {
        window.sessionStorage.setItem(
            AUTO_APPLY_SETUP_SESSION_MODIFICATIONS_KEY,
            JSON.stringify(modifications),
        );
    } catch {
        // Ignore storage failures. The marker is only used for best-effort cleanup.
    }
};

export const hasProfileModified = (): boolean =>
    readSessionModifications().profileModified === true;

export const markProfileModified = (): void => {
    writeSessionModifications({
        ...readSessionModifications(),
        profileModified: true,
    });
};

export const clearProfileModified = (): void => {
    const modifications = readSessionModifications();
    delete modifications.profileModified;
    writeSessionModifications(modifications);
};
